import { ONBOARDING_FEATURE_FLAG_NAME } from '@leagueplatform/onboarding';

export const selectOnboardingEnabledFlag = state =>
  state.featureFlags[ONBOARDING_FEATURE_FLAG_NAME];
